export function getServerBaseUrl(_ref) {
  let {
    wixCodeApi,
    appParams
  } = _ref;
  return wixCodeApi.window.rendering.env === 'backend' && appParams.baseUrls ? appParams.baseUrls.serverBaseUrl : '/';
}
//# sourceMappingURL=getServerBaseUrl.js.map